module.exports = __webpack_public_path__ + "static/img/newsmm.c616547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsmm.jpg
// module id = iR5h
// module chunks = 45